module.exports = __webpack_public_path__ + "img/setinha-left-preto-ac.bd9d44e8.svg";